import getNotes from './getNotes';
import createNote from './createNote';

export default [getNotes, createNote];
